import React from "react";
import { useFacebookStats } from "../../hooks/useFacebookStats";
import { useInstagramStats } from "../../hooks/useInstagramStats";
import { useYouTubeStats } from "../../hooks/useYouTubeStats";
import { useTwitter } from "../../hooks/useTwitter";

function FbIcon({ size = 14 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="#1877F2">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
    </svg>
  );
}

function IgIcon({ size = 14 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24">
      <defs>
        <linearGradient id="ig-tsf" x1="0" y1="1" x2="1" y2="0">
          <stop offset="0%" stopColor="#F58529" />
          <stop offset="50%" stopColor="#DD2A7B" />
          <stop offset="100%" stopColor="#8134AF" />
        </linearGradient>
      </defs>
      <path fill="url(#ig-tsf)" d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
    </svg>
  );
}

function XIcon({ size = 13, color = "#64748b" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
    </svg>
  );
}

function YtIcon({ size = 14 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="#FF0000">
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
    </svg>
  );
}

const ROWS = [
  { key: "newsday",     label: "NewsDay",             color: "#2563EB", hasFb: true,  hasIg: true,  hasYt: false },
  { key: "standard",   label: "The Standard",        color: "#059669", hasFb: true,  hasIg: false, hasYt: false },
  { key: "zimind",     label: "Zim Independent",     color: "#7C3AED", hasFb: true,  hasIg: false, hasYt: false },
  { key: "southerneye",label: "Southern Eye",        color: "#0891B2", hasFb: true,  hasIg: false, hasYt: false },
  { key: "hstv",       label: "HStv",                color: "#DC2626", hasFb: false, hasIg: false, hasYt: true  },
];

function fmt(n) {
  if (n == null) return null;
  if (n === 0) return null;
  return n;
}

function Cell({ value, loading, color, theme: t }) {
  if (loading) return <td style={{ padding: "10px 12px", textAlign: "right", color: t.textFaint, fontSize: 12 }}>…</td>;
  if (value == null) return <td style={{ padding: "10px 12px", textAlign: "right", color: t.textFaint, fontSize: 13 }}>–</td>;
  return <td style={{ padding: "10px 12px", textAlign: "right", fontWeight: 800, color: color || "#2563EB", fontSize: 12 }}>{value.toLocaleString()}</td>;
}

export function TotalSocialFollowersCard({ theme: t, isMobile }) {
  const newsdayFb     = useFacebookStats(process.env.REACT_APP_FB_NEWSDAY_PAGE_ID);
  const standardFb    = useFacebookStats(process.env.REACT_APP_FB_THESTANDARD_PAGE_ID);
  const zimindFb      = useFacebookStats(process.env.REACT_APP_FB_ZIMINDEPENDENT_PAGE_ID);
  const southerneyeFb = useFacebookStats(process.env.REACT_APP_FB_SOUTHERNEYE_PAGE_ID);
  const newsdayIg     = useInstagramStats(
    process.env.REACT_APP_FB_NEWSDAY_PAGE_ID,
    process.env.REACT_APP_FB_NEWSDAY_TOKEN
  );
  const yt = useYouTubeStats();
  const { byPub: twitterByPub, loading: twitterLoading } = useTwitter();

  const fbMap = {
    newsday:     newsdayFb,
    standard:    standardFb,
    zimind:      zimindFb,
    southerneye: southerneyeFb,
  };

  function getFb(key) {
    const s = fbMap[key];
    if (!s) return { value: null, loading: false };
    return { value: s.configured ? fmt(s.followersCount) : null, loading: s.loading };
  }

  function getIg(key) {
    if (key !== "newsday") return { value: null, loading: false };
    return { value: newsdayIg.configured ? fmt(newsdayIg.followersCount) : null, loading: newsdayIg.loading };
  }

  function getYt(key) {
    if (key !== "hstv") return { value: null, loading: false };
    return { value: yt.configured ? fmt(yt.subscriberCount) : null, loading: yt.loading };
  }

  function getTw(key) {
    const entry = twitterByPub?.[key];
    if (!entry || !entry.configured) return { value: null, loading: twitterLoading };
    return { value: fmt(entry.followers), loading: false };
  }

  function rowTotal(key) {
    const fb = getFb(key).value;
    const ig = getIg(key).value;
    const tw = getTw(key).value;
    const ytv = getYt(key).value;
    const sum = (fb || 0) + (ig || 0) + (tw || 0) + (ytv || 0);
    return sum > 0 ? sum : null;
  }

  const totalFb  = ROWS.reduce((s, r) => s + (getFb(r.key).value || 0), 0) || null;
  const totalIg  = getIg("newsday").value;
  const totalTw  = ROWS.reduce((s, r) => s + (getTw(r.key).value || 0), 0) || null;
  const totalYt  = getYt("hstv").value;
  const grandTotal = (totalFb || 0) + (totalIg || 0) + (totalTw || 0) + (totalYt || 0) || null;

  const now = new Date();
  const updatedStr = `${now.toLocaleDateString("en-US", { month: "short", day: "numeric" })} ${now.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })}`;

  const xColor = t.name === "dark" ? "#64748b" : "#94a3b8";

  return (
    <div style={{ background: t.surface, border: `1px solid ${t.border}`, borderRadius: 18, padding: isMobile ? 16 : 22, marginBottom: 24 }}>
      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 18, flexWrap: "wrap" }}>
        <div style={{ fontSize: 18 }}>👥</div>
        <div>
          <div style={{ fontSize: 13, fontWeight: 900, color: t.text, textTransform: "uppercase", letterSpacing: 1, fontFamily: "Georgia, serif" }}>Total Social Media Followers</div>
          <div style={{ fontSize: 10, color: t.textFaint, marginTop: 2 }}>Platform breakdown per publication</div>
        </div>
        <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 6 }}>
          <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#22c55e", display: "inline-block" }} />
          <span style={{ fontSize: 9, color: t.textMuted }}>Live data</span>
        </div>
      </div>

      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12, minWidth: isMobile ? 440 : 560 }}>
          <thead>
            <tr style={{ borderBottom: `2px solid ${t.border}` }}>
              <th style={{ padding: "8px 12px", textAlign: "left", color: t.textMuted, fontWeight: 700, fontSize: 9, textTransform: "uppercase", letterSpacing: 0.8 }}>Publication</th>
              <th style={{ padding: "8px 12px", textAlign: "right" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 4, color: "#1877F2" }}>
                  <FbIcon size={12} />
                  <span style={{ fontSize: 9, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.8 }}>Facebook</span>
                </div>
              </th>
              <th style={{ padding: "8px 12px", textAlign: "right" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 4, color: "#DD2A7B" }}>
                  <IgIcon size={12} />
                  <span style={{ fontSize: 9, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.8 }}>Instagram</span>
                </div>
              </th>
              <th style={{ padding: "8px 12px", textAlign: "right" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 4, color: xColor }}>
                  <XIcon size={11} color={xColor} />
                  <span style={{ fontSize: 9, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.8, color: t.textMuted }}>Twitter/X</span>
                </div>
              </th>
              <th style={{ padding: "8px 12px", textAlign: "right" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 4, color: "#FF0000" }}>
                  <YtIcon size={12} />
                  <span style={{ fontSize: 9, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.8 }}>YouTube</span>
                </div>
              </th>
              <th style={{ padding: "8px 12px", textAlign: "right", color: "#2563EB", fontSize: 9, fontWeight: 900, textTransform: "uppercase", letterSpacing: 0.8 }}>Total</th>
            </tr>
          </thead>
          <tbody>
            {ROWS.map(row => {
              const fb  = getFb(row.key);
              const ig  = getIg(row.key);
              const tw  = getTw(row.key);
              const ytv = getYt(row.key);
              const tot = rowTotal(row.key);
              return (
                <tr key={row.key}
                  style={{ borderBottom: `1px solid ${t.border}`, transition: "background 0.15s" }}
                  onMouseEnter={e => e.currentTarget.style.background = t.surface2}
                  onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                  <td style={{ padding: "10px 12px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
                      <div style={{ width: 8, height: 8, borderRadius: "50%", background: row.color, flexShrink: 0 }} />
                      <span style={{ fontSize: 12, fontWeight: 700, color: t.text }}>{row.label}</span>
                    </div>
                  </td>
                  <Cell value={row.hasFb ? fb.value : null} loading={row.hasFb && fb.loading} color="#1877F2" theme={t} />
                  <Cell value={row.hasIg ? ig.value : null} loading={row.hasIg && ig.loading} color="#DD2A7B" theme={t} />
                  <Cell value={tw.value} loading={tw.loading} color={xColor} theme={t} />
                  <Cell value={row.hasYt ? ytv.value : null} loading={row.hasYt && ytv.loading} color="#FF0000" theme={t} />
                  {/* TOTAL column */}
                  {tot != null
                    ? <td style={{ padding: "10px 12px", textAlign: "right", fontWeight: 900, color: row.color, fontSize: 13 }}>{tot.toLocaleString()}</td>
                    : <td style={{ padding: "10px 12px", textAlign: "right", color: t.textFaint, fontSize: 13 }}>–</td>
                  }
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr style={{ borderTop: `2px solid ${t.border}`, background: t.surface2 }}>
              <td style={{ padding: "11px 12px", fontWeight: 900, color: t.text, fontSize: 12, textTransform: "uppercase", letterSpacing: 0.5 }}>Total</td>
              {/* FB total */}
              {totalFb != null
                ? <td style={{ padding: "11px 12px", textAlign: "right", fontWeight: 900, color: "#1877F2", fontSize: 13 }}>{totalFb.toLocaleString()}</td>
                : <td style={{ padding: "11px 12px", textAlign: "right", color: t.textFaint, fontSize: 13 }}>–</td>
              }
              {/* IG total */}
              {totalIg != null
                ? <td style={{ padding: "11px 12px", textAlign: "right", fontWeight: 900, color: "#DD2A7B", fontSize: 13 }}>{totalIg.toLocaleString()}</td>
                : <td style={{ padding: "11px 12px", textAlign: "right", color: t.textFaint, fontSize: 13 }}>–</td>
              }
              {/* Twitter total */}
              {totalTw != null
                ? <td style={{ padding: "11px 12px", textAlign: "right", fontWeight: 900, color: xColor, fontSize: 13 }}>{totalTw.toLocaleString()}</td>
                : <td style={{ padding: "11px 12px", textAlign: "right", color: t.textFaint, fontSize: 13 }}>–</td>
              }
              {/* YT total */}
              {totalYt != null
                ? <td style={{ padding: "11px 12px", textAlign: "right", fontWeight: 900, color: "#FF0000", fontSize: 13 }}>{totalYt.toLocaleString()}</td>
                : <td style={{ padding: "11px 12px", textAlign: "right", color: t.textFaint, fontSize: 13 }}>–</td>
              }
              {/* Grand total */}
              {grandTotal != null
                ? <td style={{ padding: "11px 12px", textAlign: "right", fontWeight: 900, color: "#2563EB", fontSize: 14 }}>{grandTotal.toLocaleString()}</td>
                : <td style={{ padding: "11px 12px", textAlign: "right", color: t.textFaint, fontSize: 13 }}>–</td>
              }
            </tr>
          </tfoot>
        </table>
      </div>

      <div style={{ marginTop: 10, textAlign: "right", fontSize: 10, color: t.textFaint }}>
        Updated: {updatedStr}
      </div>
    </div>
  );
}
